var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-post-main-container"},[_c('div',{staticClass:"column-item blank-space"}),_c('div',{staticClass:"column-item post-content"},[_c('post-body'),_c('div',{staticClass:"floating-index-menu"},[_c('index-menu')],1)],1),_c('div',{staticClass:"column-item index-menu"},[_c('index-menu')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }